import { render, staticRenderFns } from "./ContactCommunicationListTable.vue?vue&type=template&id=4d859f5d"
import script from "./ContactCommunicationListTable.vue?vue&type=script&lang=js"
export * from "./ContactCommunicationListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports